import { render, staticRenderFns } from "./nutritionAdd.vue?vue&type=template&id=fee01c68"
import script from "./nutritionAdd.vue?vue&type=script&lang=js"
export * from "./nutritionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fee01c68')) {
      api.createRecord('fee01c68', component.options)
    } else {
      api.reload('fee01c68', component.options)
    }
    module.hot.accept("./nutritionAdd.vue?vue&type=template&id=fee01c68", function () {
      api.rerender('fee01c68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Nutrition/manage/nutritionAdd.vue"
export default component.exports